module.exports = __webpack_public_path__ + "static/media/img_49.d265f47b.png";